export default async function triggerSignOut(): Promise<void> {
  localStorage.removeItem('@PortalOrc:token');
  localStorage.removeItem('@PortalOrc:usuario');
}
